import { normalizeInternalReturnPath } from '@/shared/auth/return-destination';
import { SESSION_ACCESS_UPDATED_CODE } from '@/shared/auth/role-snapshot';

export { normalizeInternalReturnPath };

/**
 * Handle only authorization-update revocations. Ordinary 401/403 responses are
 * returned to the caller unchanged so existing domain error handling remains intact.
 */
export async function handleAuthenticatedResponse(response: Response): Promise<boolean> {
  if (response.status !== 401 || typeof window === 'undefined') return false;
  let body: { error?: string } | null = null;
  try {
    body = (await response.clone().json()) as { error?: string };
  } catch {
    return false;
  }
  if (body?.error !== SESSION_ACCESS_UPDATED_CODE) return false;

  const current = normalizeInternalReturnPath(
    `${window.location.pathname}${window.location.search}`,
  );
  const params = new URLSearchParams({ reason: 'access-updated' });
  if (current) params.set('redirect', current);
  window.location.replace(`/login?${params.toString()}`);
  return true;
}
